import type { DialogAutoMounterManager } from '@patsnap-biz/dialog/src/DialogAutoMounterManager';

export const DialogManager = Symbol.for('DialogManager');

export type DialogManager = DialogAutoMounterManager;
